<template>
  <vs-row vs-justify="center" id="customers-box">
    <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-xs="12"
    >
      <vs-card>
        <vs-row class="w-25">
          <vs-col vs-w="10"></vs-col>

          <vs-col vs-w="2">
            <vs-button
                id="add-service-form"
                class="mr-2 w-100"
                icon="add"
                color="primary"
                @click="open()"
            >{{ $t("paymentMethods.addPaymentButton") }}</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-card>
      <vs-card>
          <!-- ALL CUSTOMERS TAB -->
            <vs-table
                :sst="true"
                :data="paymentMethods"
            >
              <template>
                <vs-th >{{
                    $t("paymentMethods.Table.id")
                  }}</vs-th>
                <vs-th >{{
                    $t("paymentMethods.Table.title")
                  }}</vs-th>
                <vs-th>{{ $t("paymentMethods.Table.options") }}</vs-th>
              </template>

              <template>
                <vs-tr :key="index" v-for="(paymentMethod, index) in paymentMethods">
                  <vs-td>
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">
                          {{ index+1 }}
                        </h5>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td>
                    <div class="d-flex align-items-center">
                      {{ paymentMethod.title }}
                    </div>
                  </vs-td>

                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                          id="edit-reseller-button"
                          radius
                          color="warning"
                          type="border"
                          icon="edit"
                          @click="openEdit(paymentMethod)"
                      ></vs-button>
                      <vs-button
                          radius
                          color="danger"
                          type="border"
                          @click="deletePm(paymentMethod)"
                          icon="delete"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

          <!-- APPROVED CUSTOMERS TAB -->

      </vs-card>
    </vs-col>

    <Transition>
      <payment-method-from v-if="showSideBar" @close="close" @created="addPm" @updated="updatePm" :showForm.sync="showSideBar" :title="popupTitle" :pm="selectedPM"></payment-method-from>
    </Transition>
  </vs-row>
</template>

<script>
import { paymentMethodsService} from "../../_services";
import PaymentMethodFrom from "@/components/paymentMethod/paymentMethodForm.vue";
import CustomizerSidebar from "@/layout/full/customizer/CustomizerSidebar.vue";
// moment

export default {
  name: "paymentMethods",
  data: () => ({
    paymentMethods: [],
    totalItems: 1,
    totalPages: 1,
    currentPage: 1,
    current_page: 1,
    per_page: 10,
    showForm: false,
    selectedPM:null,
    popupTitle:'',
    showSideBar:false,
  }),
  methods: {
    close() {
      this.showSideBar = false;
    },
    open() {
      this.popupTitle = this.$t("paymentMethods.addPaymentButton")
      this.selectedPM = null;
      setTimeout(()=>{
        this.showSideBar = true;
      },10);
    },
    addPm(pm) {
      this.paymentMethods.push(pm);
      setTimeout(()=>{
        this.showSideBar = false;
      },10);
    },
    updatePm(pm) {
      this.paymentMethods.forEach((paymentMethod) => {
        if(paymentMethod.id === pm.id) {
          this.paymentMethods[this.paymentMethods.indexOf(paymentMethod)] = pm;
        }
      })
      setTimeout(()=>{
        this.showSideBar = false;
      },10);
    },
    openEdit(paymentMethod) {
      this.selectedPM = {...paymentMethod};
      this.popupTitle = this.$t('paymentMethods.updatePM')
      setTimeout(()=>{
        this.showSideBar = true;
      },10);
    },
    deletePm(paymentMethod) {
      this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Supprimer methode de payement",
            text: `Voulez vous vraiment supprimer cette methode de payement ?`,
            acceptText: this.$t("Toasts.AcceptButton"),
            cancelText: this.$t("Toasts.CancelButton"),
            accept: ()=> {
                this.showLoading();
                paymentMethodsService
                    .deleteType(paymentMethod.id)
                    .then(()=>{
                      this.hideLoading();
                      this.paymentMethods.splice(this.paymentMethods.indexOf(paymentMethod), 1);
                      this.notify(
                          this.$t("Toasts.Successful"),
                          'Deleted successfully',
                          "success"
                      );
                    })
                    .catch((err)=>{
                      console.log(err)
                      this.notify(
                          "Error",
                          "Unkown error",
                          "danger"
                      );
                    })
            }
      });
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#customers-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#customers-box > .con-vs-loading");
    },
  },
  computed: {
    events() {
      return this.$store.state.contactEvents;
    }
  },

  components: {
    PaymentMethodFrom

  },
  mounted() {
    this.popupTitle = this.$t("paymentMethods.addPaymentButton")
    this.showLoading();
    paymentMethodsService
        .getTypes()
        .then((res)=>{
          this.paymentMethods = res.data;
        })
        .catch((err)=>{
          console.log(err);
        })
        .finally(()=> {
              this.hideLoading();
            }
        );
  },
};
</script>
<style scoped>
.v-enter-active,
.v-leave-active {
  transition: 0.4s;
}
.v-enter-from {
  transform: translate(100%, 0);
}
.v-leave-to {
  transform: translateX(100%);
}

</style>